import { AxiosRequestConfig } from 'axios';

import ApiClient, { ApiOptions } from 'lib/clients/ApiClient';

export const API_ROOT_RESOURCE_CENTER = '/api/internal/resource_center';

class Client extends ApiClient {
  protected async sendRequest(
    uri: string,
    requestOptions: AxiosRequestConfig,
    options: ApiOptions = {},
  ) {
    const requestOptionsWithHeaders = {
      ...requestOptions,
      headers: {
        ...requestOptions.headers,
      },
    };

    const response = await super.sendRequest(uri, requestOptionsWithHeaders, options);

    return response;
  }
}

export default new Client(API_ROOT_RESOURCE_CENTER);
